// extracted by mini-css-extract-plugin
export default {"form":"NewDashboard_form__3kdGw","input":"NewDashboard_input__fH-v6","impexp":"NewDashboard_impexp__XNarT"};